<template>
  <div>
    <div class="ks-process-bar " :class="{'expand': expand}">
      <div :style="{'overflow-y': (value ? 'auto' : 'initial')}">
        <k-data-table
          :headers="headers"
          :items="filtered_processes"
          :hide-headers="!expand"
          :hide-actions="true"
          :disable-initial-sort="true"
          no-data-text=""
          class="process-table">
          <template slot="items" slot-scope="props">
            <ProcessItem v-show="(!expand && props.index == 0) || expand" :type="props.item.type" v-model="props.item"></ProcessItem>
          </template>
        </k-data-table>
        <k-btn v-show="process_list.length > filtered_processes.length" flat small @click="() => { visible_count += 10; }">Show more...</k-btn>
      </div>
      <div style="align-content: center;" @click="() => { expand = !expand; }">
        <k-btn icon no-margin ><k-icon>{{expand ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}</k-icon></k-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ProcessItem from './processbar/Item'
export default {
  props: ['value'],
  components: {
    ProcessItem
  },
  data: () => ({
    headers: [
      {text: '', value: 'status', sortable: false, width: 20},
      {text: 'Description', value: 'description', sortable: false},
      {text: "Created at", value: "created_at"},
      {text: '', value: 'actions', sortable: false, align: "right"}
    ],
    expand: false,
    visible_count: 10
  }),
  computed: {
/*    expand: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },*/
    process_count() {
      return this.process_list.length;
    },
    filtered_processes() {
      var list = _.orderBy(this.process_list, ['created_at'], ['desc']);
      return _.take(list, this.visible_count);
    },
    ...mapGetters({
      process_list: 'processes/list'
    })
  }
}
</script>

<style>
  .ks-process-bar {
    display: grid; 
    grid-template-columns: 1fr max-content;
    background: var(--ks-panel-background-color);
    border-radius: 6px;
  }
  .ks-process-bar.expand {
    height: 200px;
  }
</style>
